import Circle from 'ol/geom/Circle';
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style';
import {asArray} from 'ol/color'
var fun = require('./functions.js');

var styles = {
    data: () => ({
      circstyle: new Style({
        image: new CircleStyle({
          radius: 3.5,
          fill: new Fill({color: '#666666'}),
          stroke: new Stroke({color: '#000000', width: 1}),
        }),
      }),
      circstyle_large: new Style({
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({color: '#666666'}),
          stroke: new Stroke({color: '#000000', width: 1.5}),
        }),
      }),
      stylecache: {
        netatmo: {
          default: {},
          hovered: {}
        },
        rhm: {
          default: {},
          hovered: {}
        }
      }
    }),
    methods: {
        get_circle(feature, resolution, scale) {
            if (resolution < 100) {
              return new Circle(feature.getGeometry().getCoordinates(), 5 * resolution * scale);
            } else if (resolution > 200) {
              return new Circle(feature.getGeometry().getCoordinates(), 2.5 * resolution * scale);
            } else {
              return new Circle(feature.getGeometry().getCoordinates(), 500 * scale);
            }
        }, 
        iso_style() {
          return (feature) => {
            var z = feature.get(this.variable[this.varspace]);
            if (!(z == null || isNaN(z))) {
              return new Style({
                stroke: new Stroke({
                  color: [0, 0, 0],
                  width: 2
                }),
                text: new Text({
                  text: z.toFixed(1),
                  font: 'bold 16px Open Sans,sans-serif',
                  placement: 'line',
                  fill: new Fill({
                    color: 'rgba(0,0,0,1)'
                  }),
                  stroke: new Stroke({
                      color: 'rgba(255,255,255,1)',
                      width: 6
                  })
                })
              });
            }
          }
        },
                        air_style(hovered = false) {            
            var scale = hovered ? 15 : 13;
            var width = hovered ? 2 : 1;
            var varsize = hovered ? 12 : 10;
            var namesize = hovered ? 10 : 9;
            var offset = hovered ? -22 : -20;
            return (feature, resolution) => {

                                if (this.varspace != 'air') return;

                var z = this.aggrunit == 'hour' ? feature.get(this.variable[this.varspace]) : feature.get('param_avg');
                
                                if (!(z == null || isNaN(z))) {

                                    // If standardize is enabled but var_mean is null, skip this feature entirely
                                    if (this.standardize && this.var_mean[this.varspace][this.variable[this.varspace]] === null) return;

                                    let pdkDiv = this.pdk[this.variable[this.varspace]];
                                    let z_norm = this.standardize 
                                      ? (z - this.var_mean[this.varspace][this.variable[this.varspace]]) / pdkDiv
                                      : z / pdkDiv;

                                    let col = this.standardize    
                    ? fun.select_color_norm(
                        z_norm, 
                        this.min_value_norm[this.variable[this.varspace]], 
                        this.max_value_norm[this.variable[this.varspace]], 
                        this.iso_step[this.varspace][this.variable[this.varspace]], 
                        this.variable[this.varspace])
                    : fun.select_color(
                        z_norm, 
                        0, 
                        1.5, 
                        0.05, 
                        'pdk'
                    );

                  let black_color = [0,0,0,1];

                  var conf = feature.get('confidence');
                  let color = asArray(col);
                  color[3] = conf >= this.confidence ? 1 : 0.2;
                  black_color = conf >= this.confidence ? [0,0,0,1] : [0,0,0,0.2];

                  return [
                    new Style({
                      geometry: new Circle(feature.getGeometry().getCoordinates(), scale * resolution),
                      fill: new Fill({
                        opacity: 1.0,
                        color: col
                      }),
                      stroke: new Stroke({
                        color: black_color,
                        width: width
                      }),
                      text: new Text({
                        text: z_norm.toFixed(1),
                        font: `bold ${varsize}px Open Sans,sans-serif`,
                        fill: new Fill({
                          color: black_color
                        }),
                      })
                    }),
                    new Style({
                      text: new Text({
                        // text: this.is_russian ? feature.get('name') : feature.get('name_en'),
                        text: feature.get('name'),
                        font: `bold ${namesize}px Open Sans,sans-serif`,
                        fill: new Fill({
                          color: black_color
                        }),
                        stroke: new Stroke({
                          color: 'rgba(255,255,255,1)',
                          width: 4
                        }),
                        offsetY: offset
                      })
                    })
                  ]
                }
            }
        },
                rhm_style(hovered = false) {            
            var scale = hovered ? 15 : 13;
            var width = hovered ? 2 : 1;
            var varsize = hovered ? 12 : 10;
            var namesize = hovered ? 10 : 9;
            var offset = hovered ? -22 : -20;
            return (feature, resolution) => {

                                if (this.varspace != 'meteo') return;

                var z = feature.get(this.variable[this.varspace]);
                
                if (!(z == null || isNaN(z))) {

                    // If standardize is enabled but var_mean is null, skip this feature entirely
                    if (this.standardize && this.var_mean[this.varspace][this.variable[this.varspace]] === null) return;

                    let col = this.standardize ?  
                      fun.select_color_norm(
                          z - this.var_mean[this.varspace][this.variable[this.varspace]], 
                          this.min_value_norm[this.variable[this.varspace]], 
                          this.max_value_norm[this.variable[this.varspace]], 
                          this.iso_step[this.varspace][this.variable[this.varspace]], 
                          this.variable[this.varspace]) : 
                      fun.select_color(
                          z, 
                          this.min_value[this.variable[this.varspace]], 
                          this.max_value[this.variable[this.varspace]], 
                          this.iso_step[this.varspace][this.variable[this.varspace]], 
                          this.variable[this.varspace]
                      );

                    var conf = feature.get('confidence');

                    let color = asArray(col);
                    color[3] = conf >= this.confidence ? 1 : 0.2;

                    let black_color = conf >= this.confidence ? [0,0,0,1] : [0,0,0,0.2];
                    
                    return [
                      new Style({
                        geometry: new Circle(feature.getGeometry().getCoordinates(), scale * resolution),
                        fill: new Fill({
                          opacity: conf >= this.confidence ? 1.0 : 0.2,
                          color: color
                        }),
                        stroke: new Stroke({
                          color: black_color,
                          width: width
                        }),
                        text: new Text({
                          text: this.standardize ? (z - this.var_mean[this.varspace][this.variable[this.varspace]]).toFixed(1) : z.toFixed(1),
                          font: `bold ${varsize}px Open Sans,sans-serif`,
                          fill: new Fill({
                            color: black_color
                          }),
                        })
                      }),
                      new Style({
                        text: new Text({
                          // text: this.is_russian ? feature.get('name') : feature.get('name_en'),
                          text: feature.get(this.$i18n.t('fields.stname')),
                          font: `bold ${namesize}px Open Sans,sans-serif`,
                          fill: new Fill({
                            color: black_color
                          }),
                          stroke: new Stroke({
                            color: 'rgba(255,255,255,1)',
                            width: 4
                          }),
                          offsetY: offset
                        })
                      })
                    ]
                  }
            }
        },
        netatmo_style(hovered = false) {
            var scale = hovered ? 1.2 : 1;
            var width = hovered ? 1.5 : 0.5;
            var varsize = hovered ? 10 : 8;
            var offset = hovered ? -12 : -10;
            // here all preliminary work to minimize browser overload
            return (feature, resolution) => {
                if (this.netatmo_vars.includes(this.variable[this.varspace])) {
                  var value = feature.get(this.variable[this.varspace]);
                  if (value != null) {
                    var temp = feature.get('temperature');
                    var valid = true;
                    if (this.filtering) {
                      var temp_valid = feature.get('temp_valid');
                      if (this.filter_level == 0)
                          valid = temp_valid && (temp >= this.min_temp - this.error_temp && temp <= this.max_temp + this.error_temp);
                      else
                          valid = temp_valid && (feature.get('lcum') >= this.filter_level);
                    }
                    if (valid) {
                      // if (hovered)
                      //   return this.circstyle_large
                      // else
                      //  return this.circstyle

                      // return new Style({
                      //   image: new CircleStyle({
                      //     radius: 3.5 * scale,
                      //     fill: new Fill({
                      //       color: this.standardize ? 
                      //           fun.select_color_norm(
                      //               value - this.var_mean[this.variable[this.varspace]], 
                      //               this.min_value_norm[this.variable[this.varspace]], 
                      //               this.max_value_norm[this.variable[this.varspace]], 
                      //               this.step_value[this.variable[this.varspace]], 
                      //               this.variable[this.varspace]
                      //           ) : 
                      //           fun.select_color(
                      //               value, 
                      //               this.min_value[this.variable[this.varspace]], 
                      //               this.max_value[this.variable[this.varspace]], 
                      //               this.step_value[this.variable[this.varspace]], 
                      //               this.variable[this.varspace]
                      //           )
                      //       }),
                      //     stroke: new Stroke({
                      //         color: 'rgba(0, 0, 0, 1)',
                      //         width: width
                      //     }),
                      //   }),
                      //   text: new Text({
                      //       text: this.standardize ? (value - this.var_mean[this.variable[this.varspace]]).toFixed(1) : value.toFixed(1),
                      //       offsetY: offset,
                      //       font: `bold ${varsize}px Open Sans,sans-serif`,
                      //       fill: new Fill({
                      //           color: 'rgba(0,0,0,1)'
                      //       }),
                      //       stroke: new Stroke({
                      //           color: 'rgba(255,255,255,1)',
                      //           width: 2
                      //       }),
                      //   })
                      // })
                      return new Style({
                        geometry: this.get_circle(feature, resolution, scale),
                        fill: new Fill({
                            color: this.standardize ? 
                                fun.select_color_norm(
                                    value - this.var_mean[this.varspace][this.variable[this.varspace]], 
                                    this.min_value_norm[this.variable[this.varspace]], 
                                    this.max_value_norm[this.variable[this.varspace]], 
                                    this.iso_step[this.varspace][this.variable[this.varspace]], 
                                    this.variable[this.varspace]
                                ) : 
                                fun.select_color(
                                    value, 
                                    this.min_value[this.variable[this.varspace]], 
                                    this.max_value[this.variable[this.varspace]], 
                                    this.iso_step[this.varspace][this.variable[this.varspace]], 
                                    this.variable[this.varspace]
                                )
                            }),
                        stroke: new Stroke({
                            color: 'rgba(0, 0, 0, 1)',
                            width: width
                        }),
                        text: new Text({
                            text: this.standardize ? (value - this.var_mean[this.varspace][this.variable[this.varspace]]).toFixed(1) : value.toFixed(1),
                            offsetY: offset,
                            font: `bold ${varsize}px Open Sans,sans-serif`,
                            fill: new Fill({
                                color: 'rgba(0,0,0,1)'
                            }),
                            stroke: new Stroke({
                                color: 'rgba(255,255,255,1)',
                                width: 2
                            }),
                        })
                      })
                    }
                  }
                }
            }
        }
    }
}

export default styles;